import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PlatformAesService} from '../../user/platform-aes.service';
import {ConfService} from '../../conf.service';

@Component({
  selector: 'app-approval-page',
  templateUrl: './approval-page.component.html',
  styleUrls: ['./approval-page.component.scss']
})
export class ApprovalPageComponent implements OnInit {

  apiLoading = true;
  isError = false;
  errorMessage = '';

  successMessage = '';

  constructor(private route: ActivatedRoute,
              private platformAesService: PlatformAesService,
              private confService: ConfService) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params && params.request && params.s && params.r) {

        try {
          const request = JSON.parse(this.platformAesService.decrypt(params.s, params.r, params.request));
          this.confService.completeApiJoinsRequest(request).subscribe(resp => {
            let response: any;
            response = resp;
            this.successMessage = 'You have approved/rejected the request.';
            this.isError = false;
            if (response) {
              if (response['message']) {
                this.successMessage = response['message'];
              }
            }
            this.apiLoading = false;
          }, error => {
            this.apiLoading = false;
            this.isError = true;
            this.errorMessage = 'Error while processing your request. Please reload the page to try agian and if error persists then report to admin'
            let eMessage = '';
            if (error) {
              if (error.error) {
                if (error.error.error) {
                  eMessage = error.error.error;
                } else if (error.error.message) {
                  eMessage = error.error.message;
                } else if (error.error.body) {
                  eMessage = error.error.body;
                } else {
                  eMessage = error.error;
                }
              }
            }
            if (eMessage) {
              this.errorMessage = eMessage;
            }
          });
        } catch {
          this.apiLoading = false;
          this.errorMessage = 'Invalid request';
        }
      } else {
        this.apiLoading = false;
        this.errorMessage = 'Invalid request';
      }
    });
  }

}
